import { View, StyleSheet } from "react-native";
import CustomText from "../../../components/common/general/CustomText/CustomText";
import CustomSpacing from "../../../components/common/layout/CustomSpacing/CustomSpacing";
import { colors, semanticColors } from "../../../styles/design-system";

export const ChatIntegration = () => {
  return (
    <View style={styles.container}>
      <CustomText style={styles.sectionHeaderTitle} text="Integrations" />
      <CustomSpacing size="s" />
      <CustomText style={styles.sectionHeaderSubTitle} text="Connect Axio with your favorite tools and services" />
      <CustomSpacing size="l" />
      <View style={styles.comingSoon}>
        <CustomText text="Coming soon" style={styles.comingSoonText} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    display: "flex",
    flexDirection: "column",
    borderRadius: 32,
    padding: 24,
    borderWidth: 1,
    borderColor: "#eaecf0",
    backgroundColor: "#fff",
  },
  sectionHeaderTitle: {
    fontWeight: 600,
    fontSize: 16,
  },
  sectionHeaderSubTitle: {
    color: colors.grey[600],
    fontSize: 14,
  },
  comingSoon: {
    width: "100%",
    backgroundColor: semanticColors.surface.light,
    borderRadius: 16,
    padding: 16,
  },
  comingSoonText: {
    color: colors.grey[600],
    fontSize: 14,
    textAlign: "center",
  },
});
